<template>
    <div>
        <div class="test-details-wrap">
            <div class="test-details-item">
                <div class="test-details-icon">
                    <icon-date/>
                </div>
                <div class="test-details-content -first">
                    Дата {{ test.status === 2 ? 'відгуку' : 'тестування' }} {{ humanDate }}
                    <div class="test-details-content-controls flex-wrap" v-if="store.user && test.experts.some(item => item.user_id === store.user.id) && !test.recall_reason">
                        <button class="btn btn-outline btn-small btn-icon" @click="openReviewForm"><icon-edit/>Редагувати</button>
                        <button class="btn btn-outline btn-small btn-icon" @click="openRecallModal"><icon-revert/>Відкликати</button>
                    </div>
                </div>
            </div>
            <div class="test-details-item" v-if="(test.status === 3 || test.status === 2) && test.recall_reason">
                <div class="test-details-icon bg-warning">
                    <icon-warning/>
                </div>
                <div class="test-details-content">
                    <div class="test-details-title">{{ test.status === 2 ? 'Відгук' : 'Тест' }} відкликаний по причині:</div>
                    <div class="conclusion-text recall-text">{{ test.recall_reason }}</div>
                </div>
            </div>
            <div class="test-details-item" v-if="test.author">
                <div class="test-details-icon">
                    <icon-diagram/>
                </div>
                <div class="test-details-content">
                    <span>{{ test.author }}</span>
                </div>
            </div>
            <div class="test-details-item" v-if="test.comment">
                <div class="test-details-icon">
                    <icon-comment/>
                </div>
                <div class="test-details-content">
                    <div class="test-details-title">Деталі {{ test.status === 2 ? 'відгуку' : 'тестування' }}</div>
                    <div class="conclusion-text" v-html="test.comment"></div>
                    <Tooltip position="left" :text="test.link" v-if="test.link">
                        <a :href="test.link" target="_blank" class="test-details-link">Посилання на Джерело тестування <icon-link/></a>
                    </Tooltip>
                </div>
            </div>
            <div class="test-details-item" v-if="test.conclusion">
                <div class="test-details-icon">
                    <icon-comment/>
                </div>
                <div class="test-details-content">
                    <div class="test-details-title">Висновок</div>
                    <div class="conclusion-text" v-html="test.conclusion"></div>
                </div>
            </div>
            <div class="test-details-item" v-if="test.photos.length">
                <div class="test-details-icon">
                    <icon-photo/>
                </div>
                <div class="test-details-content">
                    <div class="test-details-title">Фото</div>
                    <div class="test-details-photos" v-if="test.photos">
                        <img v-for="(photo, index) in test.photos" :key="index"
                             :src="photo.url" :alt="photo.name" class="test-details-photo"
                             @click="$emit('opencslider', test.photos, index)">
                    </div>
                </div>
            </div>
            <div class="test-details-item"
                 v-if="test.protocols.length || test.videos.length || test.other_media.length">
                <div class="test-details-icon">
                    <icon-note/>
                </div>
                <div class="test-details-content">
                    <div class="test-details-title">Додаткові матеріали</div>
                    <div v-if="test.protocols.length">
                        <div v-for="media in test.protocols" class="test-details-addition">
                            <a :href="media.url" target="_blank" class="test-details-addition-item">
                                <icon-type-pdf v-if="media.name.includes('.pdf')"/>
                                <icon-type-text v-else/>
                                {{ media.name }}
                            </a>
                        </div>
                    </div>
                    <div v-if="test.videos.length" class="test-details-videos">
                        <div v-for="(media, index) in test.videos" class="test-details-video">
                            <video-preview :video-url="media.url"
                                           :title="media.name.substring(0, media.name.lastIndexOf('.'))"
                                           @videoopen="$emit('opencslider', test.videos, index)"/>
                        </div>
                    </div>
                    <div v-if="test.other_media.length">
                        <div v-for="media in test.other_media" class="test-details-addition">
                            <a :href="media.url" target="_blank" class="test-details-addition-item">
                                <icon-type-pdf v-if="media.name.includes('.pdf')"/>
                                {{ media.name }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="test-details-item">
                <a href="#" class="link link-feedback" @click.prevent="showFeedback">
                    <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.5 0.625C4.6875 0.625 0.75 3.775 0.75 7.625C0.75 9.4625 1.625 11.2125 3.2 12.4375C3.2 12.9625 2.85 14.3625 0.75 16.375C0.75 16.375 3.8125 16.375 6.4375 14.1875C7.4 14.45 8.45 14.625 9.5 14.625C14.3125 14.625 18.25 11.475 18.25 7.625C18.25 3.775 14.3125 0.625 9.5 0.625ZM10.375 11.125H8.625V9.375H10.375V11.125ZM11.95 6.75C11.6875 7.1 11.3375 7.275 10.9875 7.45C10.725 7.625 10.6375 7.7125 10.55 7.8875C10.375 8.0625 10.375 8.2375 10.375 8.5H8.625C8.625 8.0625 8.7125 7.8 8.8875 7.5375C9.0625 7.3625 9.4125 7.1 9.85 6.8375C10.1125 6.75 10.2875 6.575 10.375 6.4C10.4625 6.225 10.55 5.9625 10.55 5.7875C10.55 5.525 10.4625 5.35 10.2875 5.175C10.1125 5 9.85 4.9125 9.5875 4.9125C9.325 4.9125 9.15 5 8.975 5.0875C8.8 5.175 8.7125 5.35 8.7125 5.6125H6.9625C7.05 5 7.3125 4.475 7.75 4.125C8.1875 3.775 8.8 3.6875 9.5875 3.6875C10.375 3.6875 11.075 3.8625 11.5125 4.2125C11.95 4.5625 12.2125 5.0875 12.2125 5.7C12.3 6.05 12.2125 6.4 11.95 6.75Z" fill="currentcolor"/>
                    </svg>
                    Є питання чи зауваження по тесту?
                </a>
            </div>
            <TestReaction @showshare="renderShare" :test-id="test.id" :likes="test.vote_good" :dislikes="test.vote_bad" :user-data="userData"/>
            <TestComments :is-login="true" :test-id="test.id" :user-data="userData" :removeCommentId="store.removeCommentData ? store.removeCommentData.id : null"/>
        </div>
    </div>
</template>

<script>
import IconDate from '../icons/IconDate';
import IconDiagram from '../icons/IconDiagram';
import IconComment from '../icons/IconComment';
import IconPhoto from '../icons/IconPhoto';
import IconNote from '../icons/IconNote';
import IconTypeText from '../icons/IconTypeText';
import Tooltip from '../Tooltip';
import IconLink from '../icons/IconLink';
import IconTypePdf from '../icons/IconTypePdf';
import TestReaction from './parts/TestReaction';
import VideoPreview from './parts/VideoPreview.vue';
import IconWarning from '../icons/IconWarning';
import {commonPageData} from '../../common';
import TestComments from './parts/TestComments.vue';
import {tourniquetStore} from '../../store/store';
import IconEdit from "../icons/IconEdit.vue";
import IconRevert from "../icons/IconRevert.vue";
import {vueData} from "../../turniket";
import RecallReviewModal from "./RecallReviewModal.vue";

export default {
    name: "TestItemContent",
    components: {
        RecallReviewModal,
        IconRevert,
        IconEdit,
        TestComments,
        IconWarning,
        TestReaction,
        IconTypePdf,
        IconLink,
        Tooltip,
        VideoPreview,
        IconTypeText, IconNote, IconPhoto, IconComment, IconDiagram, IconDate
    },
    props: ['test'],
    setup() {
        const store = tourniquetStore();
        return {store};
    },
    computed: {
        humanDate() {
            const months = [
                'січня', 'лютого', 'березня', 'квітня', 'травня', 'червня', 'липня', 'серпня', 'вересня', 'жовтня', 'листопада', 'грудня'
            ]
            const dateArr = this.test.date.split('.');
            const month = months[dateArr[1] - 1];
            return `${dateArr[0]} ${month} ${dateArr[2]} року`
        },
        userData() {
            const data = JSON.parse(localStorage.getItem('@fpjs@client@__null__null__true'));
            if(data) {
                return {
                    visitorId: data.body.visitorId,
                    requestId: data.body.requestId,
                }
            }
        }
    },
    methods: {
        openRecallModal() {
            this.store.showRecallModal(this.test.id)
        },
        openReviewForm() {
            vueData.tourniquetReviewName = document.querySelector('[data-block="tourniquet-name"]').innerText;
            vueData.tourniquetReviewId = +document.querySelector('[data-block="tourniquet-name"]').dataset.id;
            vueData.tourniquetReviewEditedId = this.test.id;
            vueData.tourniquetReviewText = this.test.comment;
            vueData.tourniquetReviewConclusion = this.test.conclusion;
            vueData.isEdit = true;
            vueData.tourniquetReviewImages = this.test.photos;
            vueData.tourniquetReviewDocs = this.test.other_media;
            vueData.showReviewForm = true;
        },
        showFeedback() {
            commonPageData.feedbackFormOption = 'test';
            commonPageData.feedbackFormshow = true;
            commonPageData.feedbackFormTest = this.test.id;
        },
        renderShare() {
            window.location.hash = this.test.id;
            this.$parent.$emit('rendershare')
        }
    }
}
</script>
